import * as React from 'react';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { applyAttributeStyles, joinClass } from './symbolUtils';
const Group = ({ children, conditionalState, hoverAnimation, inEditor, innerRef, symbol, timelineRefId, }) => {
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const { attributes, position, styles } = conditionalState;
    const attributeStyles = applyAttributeStyles(attributes, {});
    const className = joinClass(symbol.id, conditionalState.id, clickClass);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: innerRef, onClick: onClick, position: position, style: Object.assign(Object.assign(Object.assign({}, mouseEventStyles), styles), attributeStyles), inEditor: inEditor }, children));
};
export default Group;
